import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { OrdersalesTiendaListComponent } from './ordersales-tienda-list/ordersales-tienda-list.component';
import { OrdersalesTiendaStep1Component } from './ordersales-tienda-step1/ordersales-tienda-step1.component';
import { OrdersalesTiendaStep1ListComponent } from './ordersales-tienda-step1-list/ordersales-tienda-step1-list.component';
import { OrdersalesTiendaStep2ListComponent } from './ordersales-tienda-step2-list/ordersales-tienda-step2-list.component';

const routesOrderSales: Routes = [
    { path: 'ordersales-tv-monitoring', component: OrdersalesTiendaListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-tv-step1', component: OrdersalesTiendaStep1Component, canActivate: [AuthGuard] },
    { path: 'ordersales-tv-step1-list', component: OrdersalesTiendaStep1ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-tv-step2-list', component: OrdersalesTiendaStep2ListComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routesOrderSales)],
  exports: [RouterModule],
})

export class OrderSalesTiendaRoutingModule { }